require('../modules/es6.parse-int');
module.exports = require('../modules/_core').parseInt;



//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/core-js/es6/parse-int.js
// module id = ../../../../core-js/es6/parse-int.js
// module chunks = 0